import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: NSAI-3060 — true when SIEM_EXPORT_ENABLED is on for the deployment.
// Read from the public /app-config endpoint, like every other feature flag.
// Per-organization SIEM settings only take effect while global export is on, so
// with the flag off the Settings → SIEM export tab is hidden rather than
// offering a screen whose every control is inert. The owner-only endpoints
// behind it enforce ownership themselves — this decides visibility, not access.
export const useSiemExportEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isSiemExportEnabled ?? false;
};
